<template>
  <div class="container py-4">
    <router-link
      to="/"
      type="button"
      class="mb-4 noprint"
      style="width: 8rem; padding: 0; color: #031425"
    >
      <svg
        data-slot="icon"
        fill="none"
        stroke-width="1.5"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
      </svg>
      <p>Ver eventos</p>
    </router-link>
    <div v-if="info" class="report">
      <p class="mb-4">Reporte de recargas</p>
      <table class="table bordered responsive">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Correo</th>
            <th>Método de pago</th>
            <th>Puntos</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in info" :key="index">
            <td>{{ item.id }}</td>
            <td>{{ item.firstName }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.paymentMethod }}</td>
            <td>{{ item['sum(uwt.movedPoints)'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import api from '../api';
export default {
  data() {
    return {
      info: null
    };
  },
  async mounted() {
    await this.getReport();
  },
  methods: {
    async getReport() {
      const { eventId } = this.$route.params;
      const { token } = this.$store.state.auth;
      const { data, status } = await api.getRechargePoints(eventId, token);
      if (status) {
        this.info = data;
      }
      console.log(data);
    }
  }
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0;
}
button,
a {
  background: transparent;
  border: 1px solid transparent;
  display: flex;
  font-weight: 700;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  padding: 0.5rem;
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:disabled {
    opacity: 0.6;
  }
}
a {
  &:hover {
    text-decoration: underline;
    text-underline-offset: 0.25rem;
  }
}
table {
  width: 100%;
  border: 1px solid #cecece;
}
.report {
  background: #fff;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 10px 15px -3px #00000020, 0 4px 6px -4px #00000020;
  p {
    font-size: 1.5rem;
    font-weight: 600;
  }
}
</style>
